var _defs, _rect, _ellipse, _ellipse2, _g, _g2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    preserveAspectRatio: "xMidYMid slice",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poBg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#010205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#020812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#010205"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poLeftRibbon",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0066ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#0088ff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#00c8ff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#00ffd0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#00ffb0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92%",
    stopColor: "#00ff90",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00ff80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poLeftCore",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4499ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#66ddff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#88ffee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#aaffdd",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#ccffcc",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eeffee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poRightRibbon",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ff80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#00ff90",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#00ffc0",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#00e8ff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#00b8ff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92%",
    stopColor: "#0088ff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0066ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "poRightCore",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#aaffcc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#88ffdd",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#66ffee",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#66eeff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#88ddff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#aaccff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "poGlowStrong",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "poGlowMed",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "poGlowCore",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "poSoft",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "poCenterFade",
    cx: "50%",
    cy: "50%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "white",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "poFadeMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#poCenterFade)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "poVignette",
    cx: "50%",
    cy: "50%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "black",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "black",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "black",
    stopOpacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#poBg)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 540,
    rx: 600,
    ry: 350,
    fill: "#00aaff",
    opacity: 0.04,
    filter: "url(#poSoft)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 540,
    rx: 400,
    ry: 250,
    fill: "#00ffcc",
    opacity: 0.03,
    filter: "url(#poSoft)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#poFadeMask)",
    transform: "translate(0, 150)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowStrong)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -300 880 Q 200 680, 500 600 T 960 540 T 1400 480 T 2200 560",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -280 800 Q 180 620, 480 550 T 960 510 T 1420 460 T 2220 510",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -260 720 Q 160 560, 460 500 T 960 480 T 1440 440 T 2240 460",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -240 640 Q 140 500, 440 450 T 960 450 T 1460 420 T 2260 410",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowMed)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -300 880 Q 200 680, 500 600 T 960 540 T 1400 480 T 2200 560",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -280 800 Q 180 620, 480 550 T 960 510 T 1420 460 T 2220 510",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -260 720 Q 160 560, 460 500 T 960 480 T 1440 440 T 2240 460",
    fill: "none",
    stroke: "url(#poLeftRibbon)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowCore)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -300 880 Q 200 680, 500 600 T 960 540 T 1400 480 T 2200 560",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -280 800 Q 180 620, 480 550 T 960 510 T 1420 460 T 2220 510",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -260 720 Q 160 560, 460 500 T 960 480 T 1440 440 T 2240 460",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -240 640 Q 140 500, 440 450 T 960 450 T 1460 420 T 2260 410",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowCore)",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -320 920 Q 210 710, 510 620 T 960 560 T 1380 500 T 2180 580",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -310 860 Q 205 670, 505 590 T 960 545 T 1390 490 T 2190 560",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -290 780 Q 195 610, 495 540 T 960 515 T 1405 470 T 2205 530",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -270 700 Q 175 550, 475 490 T 960 485 T 1425 450 T 2225 480",
    fill: "none",
    stroke: "url(#poLeftCore)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#poFadeMask)",
    transform: "translate(0, -120)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowStrong)",
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -200 180 Q 300 300, 600 380 T 960 520 T 1300 640 T 2200 520",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -220 260 Q 320 360, 620 430 T 960 560 T 1280 680 T 2180 580",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -240 340 Q 340 420, 640 480 T 960 600 T 1260 720 T 2160 640",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -260 420 Q 360 480, 660 530 T 960 640 T 1240 760 T 2140 700",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowMed)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -200 180 Q 300 300, 600 380 T 960 520 T 1300 640 T 2200 520",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -220 260 Q 320 360, 620 430 T 960 560 T 1280 680 T 2180 580",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -240 340 Q 340 420, 640 480 T 960 600 T 1260 720 T 2160 640",
    fill: "none",
    stroke: "url(#poRightRibbon)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowCore)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -200 180 Q 300 300, 600 380 T 960 520 T 1300 640 T 2200 520",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -220 260 Q 320 360, 620 430 T 960 560 T 1280 680 T 2180 580",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -240 340 Q 340 420, 640 480 T 960 600 T 1260 720 T 2160 640",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -260 420 Q 360 480, 660 530 T 960 640 T 1240 760 T 2140 700",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#poGlowCore)",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -180 140 Q 290 280, 590 360 T 960 510 T 1310 630 T 2210 500",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -200 220 Q 310 340, 610 410 T 960 550 T 1290 670 T 2190 560",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -230 300 Q 330 400, 630 470 T 960 590 T 1270 710 T 2170 620",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -250 380 Q 350 460, 650 520 T 960 630 T 1250 750 T 2150 680",
    fill: "none",
    stroke: "url(#poRightCore)",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.4
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#poVignette)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticBg);
export default __webpack_public_path__ + "static/media/static-bg.03e99437cdefd3398cf655096f82c860.svg";
export { ForwardRef as ReactComponent };